import ClickOutside from 'vue-click-outside';

export const ManagePopupMixin = {
    directives: { ClickOutside },
    data() {
        return {
            isPopupOpen: false,
            hideScroll: true
        }
    },
   /* watch: {
        isPopupOpen: {
            handler(isOpen) {
                if (this.shouldHideScroll()) {
                    document.body.style.overflowY = isOpen ? 'hidden' : 'initial';
                }
            },
            immediate: true
        }
    },*/
    methods: {
        openPopup() {
            this.isPopupOpen = true;
        },
        togglePopup() {
            this.isPopupOpen = !this.isPopupOpen;
        },
        closePopup(event) {
            if (this.isPopupOpen) {
                this.isPopupOpen = false;
            }
        },
        shouldHideScroll() {
            return this.hideScroll;
        }
    },
    beforeDestroy() {
        this.closePopup();
        if (this.shouldHideScroll()) {
            document.body.style.overflowY = 'initial';
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/ManagePopupMixin.js